import { handleErrors } from './ErrorActions';
import smartSolveApi from '../api/instances/smartsolve';
import { FETCH_APP_NAVIGATION_SUCCEEDED } from '../constants/NavigationConstants';

function fetchAppNavigationSucceeded(navigation) {
  return {
    type: FETCH_APP_NAVIGATION_SUCCEEDED,
    navigation,
  };
}

export function fetchAppNavigationFromServer() {
  return (dispatch) => {
    return smartSolveApi
      .post('/topmenu', {})
      .then((response) => {
        const { data } = response;
        if (data.hasError) {
          dispatch(handleErrors(data.errors));
        } else {
          dispatch(fetchAppNavigationSucceeded(data.TopMenu));
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(`Fetching top menu failed: ${JSON.stringify(error)}`);
      });
  };
}
